import { useTranslation } from 'react-i18next'

import { CITIES } from '../../data/cities.ts'
import type { Rally } from '../../data/rallies.ts'

interface CityProps {
  city: string
  rally?: Rally
}

function CityOG({ city, rally }: CityProps) {
  const { t } = useTranslation()

  const ns = rally?.citiesI18n ?? 'cities'
  const link = (rally?.cities ?? CITIES)[city]?.link || null

  return (
    <li key={city} className='list-none'>
      {link ? (
        <a
          href={link}
          target='_blank'
          rel='noopener noreferrer'
          className='inline-flex items-center space-x-1 active:opacity-70 transition-opacity'
        >
          <span className='font-bold hover:underline'>{t(`${ns}.${city}.time`)}</span>
          <span>🔗</span>
        </a>
      ) : (
        <span className='font-bold'>{t(`${ns}.${city}.time`)}</span>
      )}
      <div className='text-sm font-semibold text-blue-900'>{t(`${ns}.${city}.location`)}</div>
    </li>
  )
}

export default CityOG
